diy.angular.registerFactory('diyfmfoldermodel', [
    '$q', 
    '$timeout', 
    '$injector', 
    'diyfmsubsectionmodel', 
    'diyl10n', 
    'diyfmfolders', 
    'diyfmsourcestorage', 
    'diyfmfileitemmodel',
    'diyfmselectiondata', 
    'diyfmuploadqueue', 
    'diyfmconststorage', 
    'diyfilevalidator',
    'diyglobalevents',
function(
    $q, 
    $timeout, 
    $injector, 
    diyfmsubsectionmodel, 
    diyl10n, 
    diyfmfolders, 
    diyfmsourcestorage, 
    diyfmfileitemmodel,
    diyfmselectiondata, 
    diyfmuploadqueue, 
    diyfmconststorage, 
    diyfilevalidator,
    diyglobalevents
){
    
    var 
        fileResource = diyfmsourcestorage.getItemsProvider()
    ;

    // constructor
    var diyfmfoldermodel = function (id, title, folderResource) {
        var self = this;
        
        this._folderResource = folderResource || new diyfmfolders();
        
        this._observers = [];
        
        diyfmsubsectionmodel.call(this, id, title, diyfmsourcestorage, 'customerFiles'); //call parent constructor
    };
    
    // diyfmfoldermodel extends diyfmsubsectionmodel
    diyfmfoldermodel.prototype = Object.create(diyfmsubsectionmodel.prototype);
    
    // public methods
    angular.extend(diyfmfoldermodel.prototype, {
        _emptyActions: [], // used for folders that are not yet saved on server side
        _actions: [
            {
                name: 'rename',
                icon: 'rename',
                title: diyl10n('filemanager.sections.menu.rename')
            }, {
                name: 'delete',
                icon: 'trash',
                title: diyl10n('filemanager.sections.menu.delete')
            }
        ],
        _itemActions: [{
            name: 'rename',
            icon: 'rename',
            title: diyl10n('filemanager.items.menu.rename')
        }, {
            name: 'delete',
            icon: 'trash',
            title: diyl10n('filemanager.items.menu.delete')
        }, {
            name: 'download',
            icon: 'download',
            title: diyl10n('filemanager.items.menu.download')
        }, {
            name: 'preview',
            icon: 'preview',
            title: diyl10n('filemanager.items.menu.preview')
        }],
        isNew: function() {
            return !this._folderResource.id;
        },
        'delete': function() {
            var self = this;
            return this._folderResource.$delete().then(function(){
                self.notifyObservers('deleted');
            });
        },
        setTitle: function(newTitle) {
            var self = this;
            diyfmsubsectionmodel.prototype.setTitle.apply(this, arguments);// call super
            
            this._folderResource.name = newTitle;
            
            if (!this._folderResource.id) {
                this._folderResource.$create().then(function(data) {
                    self.setId({type: diyfmconststorage, id: parseInt(data.id, 10)});
                });
            } else {
                this._folderResource.$update();
            }
        },
        
        getActions: function() {
            // actions are supported only for saved
            // folders, that have an id identifier
            if (this._folderResource.id) {
                return this._actions;
            } else {
                return this._emptyActions;
            }
        },
        
        getDefaultParams: function()
        {
            return {
                folderId: this._folderResource.id
            }
        },
        
        _instanciateItem: function(resource) {
            return new diyfmfileitemmodel(resource); 
        },        
        
        uploadFiles: function(files) {
            var self = this, uploadQueue, deferred = $q.defer(), uploadErrors = [], itemsCreated = [];

            if (!this._items) {
                this._items = [];
            }
            // to keep the order in which user selected files
            // we should reverse them here
            var reversedFiles = [];
            angular.forEach(files, function(file, i) {
                reversedFiles.unshift(file);
            });

            angular.forEach(reversedFiles, function(file, i) {
                // client-side validation of the file
                var validation = diyfilevalidator.validate(file, {
                    maxSize: 20971520, // 20 MB
                    type: ['.jpg', '.jpeg', '.png', '.gif']
                });
                // if file passed validation, add it
                if (validation === true) {
                    var fileItem = new diyfmfileitemmodel();
                    fileItem.setName(file.name);
                    fileItem.setFolderId(self.getFolderId());
                    self._items.unshift(fileItem);
                    fileItem.$create(file).then(function(item) {
                        deferred.notify({item: item});
                        itemsCreated.push(item);
                    }, function(reason) {
                        // error or user cancel
                        self.deleteItems([fileItem]);

                        if (reason !== 'cancel') { // if error (not user cancel)
                            // log error that happened during server-side upload
                            uploadErrors.push({
                                file: file,
                                error: reason
                            });
                        }
                    });
                } else {
                    // log client-side validation errors
                    uploadErrors.push({
                        file: validation.file,
                        error: validation.error
                    });
                }
            });

            uploadQueue = diyfmuploadqueue.get('storageFiles');
            // if not all failed, start upload
            if (uploadErrors.length !== files.length) {
                uploadQueue.start();

                uploadQueue.getPromise().then(function() {
                    self.notifyObservers('itemsCreated', itemsCreated);
                    deferred.resolve({items: itemsCreated, uploadErrors: uploadErrors});
                });
            } else { // if all failed, cancel and return errors
                uploadQueue.cancel();
                deferred.resolve({uploadErrors: uploadErrors});
            }

            return deferred.promise;
        },

        canMoveTo: function() { 
            return !this.isNew();
        }, 
        
        _removeItemsOnMove: function(moveItems) {
            var i, index;
            if (typeof this._items === 'undefined') {
                return;
            }
            for (i = 0; i < moveItems.length; i++) {
                index = this._items.indexOf(moveItems[i]);
                if (index !== -1) {
                    this._items.splice(index, 1);
                }
            }
        },

        moveItems: function(moveItems, destinationFolder) {
            var 
                i,
                self = this,
                idsToMove = [], 
                itemsToMove = [],
                folderId = destinationFolder.getFolderId()
            ;
            // we should verify if they are not already in this 
            // folder (could happen when dragging from AllImagesSubsection)
            for(i = 0; i < moveItems.length; i++) {
                if (moveItems[i].getFolderId() !== folderId) {
                    itemsToMove.push(moveItems[i]);
                    idsToMove.push(moveItems[i].getId());
                }
            }
            if (itemsToMove.length > 0) {
                this._removeItemsOnMove(itemsToMove);
                this.notifyObservers('beforeItemsUpdated', itemsToMove);
                
                for(i = 0; i < itemsToMove.length; i++) {
                    itemsToMove[i].setFolderId(folderId);
                }
                
                fileResource.update({ids: idsToMove, folderId: folderId}, function(){
                    self.notifyObservers('itemsUpdated', itemsToMove);
                });
                
                destinationFolder._afterItemsMoved(moveItems);
            }
        },
        
        _afterItemsMoved: function(moveItems) {
            // we should invalidate loaded items
            // they should be freshly loaded from server
            // because we cannot guaranty correct sorting order
            // if we move them also client-side
            this.clearItemsCache();
        },

        deleteItems: function(deleteItems) {
            var index, deleteItemsIds = [], itemId, self = this, itemsDeleted = [];
            
            // XXX iterate in reverse order, because it may be that
            // deleteItems are the same as 'select' collection
            // so deleting it from 'select' will modify deleteItems array
            for (var i = deleteItems.length - 1; i >= 0; i--) {
                itemId = deleteItems[i].getId();
                // checking if this is a persisted resource, otherwise 
                // we should not delete it on the server
                if (itemId) {
                    deleteItemsIds.push(itemId);
                    itemsDeleted.push(deleteItems[i]);
                }
                if ((index = this._items.indexOf(deleteItems[i])) > -1) {
                    this._items.splice(index, 1);
                }
                diyfmselectiondata.removeItem(deleteItems[i], ['select', 'insert']);
            }
            if (deleteItemsIds.length > 0) {
                fileResource.batchDelete(deleteItemsIds).then(function(){
                    self.notifyObservers('itemsDeleted', itemsDeleted);
                    diyglobalevents.trigger('diy-editor-filemanager-deletedFiles', {});
                });
            }
        },
        
        getFolderId: function() {
            return this.getId().id;
        },
        /* Implementing Observer pattern
         * a folder can be observable
         */
        attachObserver: function(observer){
            this._observers.push(observer);
        },
        detachObserver: function(observer) {
            var obsIndex = this._observers.indexOf(observer);
            if (objIndex > -1) {
                this._observers.splice(obsIndex, 1);
            }
        },
        notifyObservers: function(event, data) {
            var observer;
            for (var i = 0, len = this._observers.length; i < len; i++) {
                observer = this._observers[i];
                observer.update.apply(observer, [this, event, data]);
            }
        },
        /* Implementing Observer pattern
         * a folder can observe
         */
        update: function(subject, event, data) {
            
            diyfmallimagesmodel = $injector.get('diyfmallimagesmodel');
            
            if (subject instanceof diyfmallimagesmodel) {
                switch(event) {
                    case 'itemsDeleted':
                    case 'itemsCreated':
                    case 'beforeItemsUpdated':
                        if (this._items !== undefined) {
                            var items = data;
                            for (var i = 0, len = items.length; i < len; i ++) {
                                if (items[i].getFolderId() == this.getFolderId()) {
                                    // TODO make a smarter handler that actually updates it's local cache
                                    // based on provided data
                                    this.clearItemsCache();
                                    break;
                                }
                            }
                        }
                        break;
                }
            }
        }
    });
    
    return diyfmfoldermodel;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmfoldermodel.js
 ** module id = 955
 ** module chunks = 0
 **/